module.exports = __webpack_public_path__ + "img/kkgfwbh.67eb343a.png";